import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-568bb298"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { id: "printinfo" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  class: "button",
  onclick: "window.close()"
}
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { id: "print" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "titlebar" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "brand" }, [
    /*#__PURE__*/_createElementVNode("i", null, "easy"),
    /*#__PURE__*/_createTextVNode("NWK")
  ])
], -1))
const _hoisted_9 = { id: "egobar" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "columns" }
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "panel-heading" }
const _hoisted_15 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NetworkMap = _resolveComponent("NetworkMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createPdf && _ctx.createPdf(...args)))
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, { icon: "file-pdf" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("printorpdf")), 1)
        ]),
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_font_awesome_icon, { icon: "arrow-left" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("closeandback")), 1)
        ])
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.t("printtext")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.t("printtext2")), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t("ego") + ": " + _ctx.ego.name), 1),
        (_ctx.versions.length && _ctx.currentVersion >= 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.t("currentversion") +
            (_ctx.visibleNWKVersion?.title || "") +
            _ctx.t("versionfrom")) + _toDisplayString(_ctx.visibleNWKVersion?.date?.substring(8, 10) +
            "." +
            _ctx.visibleNWKVersion?.date?.substring(5, 7) +
            "." +
            _ctx.visibleNWKVersion?.date?.substring(0, 4)) + "  ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_ctx.ego.currentGender
              ? _ctx.t("genders") + ": " + _ctx.getGenderTranslation(_ctx.ego.currentGender)
              : ""), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.ego.age.length >= 1 ? _ctx.t("age") + ": " + _ctx.ego.age : ""), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.ego.note.length >= 1 ? _ctx.t("note") + ": " + _ctx.ego.note : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t("contacts")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alteri, (alter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "panel-block"
            }, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.getAlterName(alter)), 1),
              _createElementVNode("p", null, _toDisplayString(alter.role), 1),
              _createElementVNode("p", null, _toDisplayString(alter.age.length >= 1 ? _ctx.t("age") + ": " + alter.age : ""), 1),
              _createElementVNode("p", null, _toDisplayString(alter.human ? "" : _ctx.t("humanno")), 1),
              _createElementVNode("p", null, _toDisplayString(alter.human
                  ? _ctx.t("genders") +
                    ": " +
                    _ctx.getGenderTranslation(alter.currentGender)
                  : _ctx.t("category") + ": " + alter.currentGender), 1),
              _createElementVNode("p", null, _toDisplayString(alter.deceased ? _ctx.t("deceasedyes") : ""), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.t("relationship")) + ": " + _toDisplayString(alter.edgeType == 1
                  ? _ctx.t("existing")
                  : alter.edgeType == 2
                  ? _ctx.t("multiplex")
                  : _ctx.t("nocurrentrelationship")), 1),
              _createElementVNode("p", null, _toDisplayString(alter.note.length >= 1 ? _ctx.t("note") + ": " + alter.note : ""), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_NetworkMap)
    ])
  ]))
}